$( document ).ready(function() {
    
    // Slick Carousel
    
	$('.slick-simple').slick({
	  dots: true,
	  infinite: true,
	  speed: 300,
	  slidesToShow: 2,
	  variableWidth: false,
	  responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '40px',
	        slidesToShow: 1
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        arrows: false,
	        centerMode: false,
	        centerPadding: '40px',
	        variableWidth: false,
	        slidesToScroll: 1,
	        slidesToShow: 1
	      }
	    }
	  ]
	});
	
	
	// Homepage centered carousel
	
	$('.center-carousel').slick({
	  centerMode: true,
	  variableWidth: true,
	  centerPadding: '0px',
	  slidesToShow: 3,
	  autoplay: true,
	  autoplaySpeed: 2000,
	  responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '40px',
	        slidesToShow: 3
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        arrows: false,
	        centerMode: false,
	        centerPadding: '40px',
	        variableWidth: false,
	        slidesToScroll: 1,
	        slidesToShow: 1
	      }
	    }
	  ]
	});
	
	
	// Slider Sync - Gallery style
	
	 $('.slider-for').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '.slider-nav'
	});
	$('.slider-nav').slick({
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  asNavFor: '.slider-for',
	  dots: true,
	  centerMode: true,
	  focusOnSelect: true
	});
		
    
    
    
});

$(() => {

  $('.form-group').each((i, e) => {
    $('.form-control', e).
    focus(function () {
      e.classList.add('not-empty');
    }).
    blur(function () {
      this.value === '' ? e.classList.remove('not-empty') : null;
    });

  });

});



// Top of page

var distance = $('.sticky-top').offset().top;

$(window).scroll(function() {
    if ( $(this).scrollTop() >= distance ) {
        $('div.sticky-top').addClass('reached');
    } else {
        $('div.sticky-top').removeClass('reached');
    }
});


// Scroll Bar

(function($){
	$(window).on("load",function(){
		
		$.mCustomScrollbar.defaults.scrollButtons.enable=true; //enable scrolling buttons by default
		// $.mCustomScrollbar.defaults.axis="yx"; //enable 2 axis scrollbars by default
		
		$(".content-l").mCustomScrollbar();
		
		$(".content-d").mCustomScrollbar({theme:"dark"});
		
		$(".content-l2").mCustomScrollbar({theme:"light-2"});
		
		$(".content-d2").mCustomScrollbar({theme:"dark-2"});
		
		
		
	});
})(jQuery);
